import { LETTERS } from '@components/UI-Components/StandardTableView'
import { action, observable } from 'mobx'

export class MoreFilterUIStore {
  @observable moreFilterSearchKey: string = ''

  isMatchingInitialsAlphabet = (letter: string, item: any) => {
    const valueToTest = item
    const firstLetter = valueToTest.charAt(0).toUpperCase()
    if ((letter === '#' && /^[^A-Z]$/.test(firstLetter)) || letter === firstLetter) {
      return true
    } else {
      return false
    }
  }

  getData(values, defaultEmptyText) {
    let updatedData = values
    updatedData = LETTERS.reduce((acc, letter) => {
      const record = updatedData
        ?.filter(element => {
          const firstLetter = (element?.value?.toString() || defaultEmptyText)
            ?.charAt(0)
            .toUpperCase()
          if (
            (letter === '#' && /^[^A-Z]$/.test(firstLetter)) ||
            letter === firstLetter
          ) {
            return true
          } else {
            return false
          }
        })
        .map(item => ({ ...item, initial: letter, type: 'record' }))
      if (record && record.length) {
        acc.push({ id: letter, name: letter, initial: letter, type: 'header' })
        acc = acc.concat(record)
      }
      return acc
    }, [])
    return updatedData
  }

  @action onMoreFilterSearchKeyChange = key => {
    this.moreFilterSearchKey = key
  }

  @action resetFilterSearchKey = () => {
    this.moreFilterSearchKey = ''
  }
}
